import { Context } from '~/types/ext/vue'

export const requireIssueCode = (ctx: Context): void => {
  if (!ctx.store.state.registerUser) {
    return ctx.redirect('/auth/login')
  }
}

export const requireVerify = (ctx: Context): void => {
  if (!ctx.store.state.registerUser) {
    return ctx.redirect('/auth/login')
  }
  if (ctx.store.state.registerUser && !ctx.store.state.registerUser.token) {
    return ctx.redirect('/auth/login')
  }
}
